import React, { useEffect } from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { NamePath } from 'antd/lib/form/interface';
import { UseQueryResult } from '@tanstack/react-query';
import { TaskSelect } from '@/components/ui/Inputs/TaskSelect';
import { TaskDTO } from '@/components/ui/Inputs/types/response/task';

interface TasksProps {
	fileId: string;
	cycleId: string;
	fieldName: NamePath;
	tasks: UseQueryResult<TaskDTO[], unknown>;
}

const { useFormInstance, useWatch } = Form;

export function Tasks({ fieldName, tasks, cycleId, fileId }: Readonly<TasksProps>): JSX.Element {
	const form = useFormInstance();
	const taskId = useWatch(fieldName, form);

	const getExistingTaskId = () => {
		return tasks.data?.find((task) => task.file && task.file.find(({ id }) => id === fileId))?.id;
	};

	async function handleTaskSelect(id: string) {
		form.setFieldValue(fieldName, id);
	}

	async function handleClearTask() {
		form.setFieldValue(fieldName, undefined);
	}

	const existingTaskId = getExistingTaskId();

	useEffect(() => {
		const currentFormValue = form.getFieldValue(fieldName);
		if (existingTaskId && !currentFormValue) {
			form.setFieldValue(fieldName, existingTaskId);
		}
	}, [existingTaskId]);

	return (
		<Col xs={24} sm={12}>
			<Form.Item
				name={fieldName}
				label={I18n.get('Task list ID (TLID)')}
				labelCol={{ span: 24 }}
				rules={[
					{
						required: true,
						message: I18n.get('Select the task')
					}
				]}
			>
				<TaskSelect
					taskId={taskId}
					cycleId={cycleId}
					tasks={tasks.data}
					loading={tasks.isFetching}
					handleClearTask={handleClearTask}
					handleSelectTask={handleTaskSelect}
					disabled={tasks.isLoading || tasks.isFetching}
					fieldName={['bera_report', ...(Array.isArray(fieldName) ? fieldName : [fieldName])]}
				/>
			</Form.Item>
		</Col>
	);
}
